export class ListSqlEnginesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSqlEnginesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSqlEngineBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlEnginesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
